"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removePostLock = exports.refreshPostLock = exports.reorderPosts = exports.duplicatePost = exports.emptyTrash = exports.deletePost = exports.updatePost = exports.getPost = exports.addPost = void 0;

var _ = require(".");

var addPost = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, dispatch, config) {
    var siteID, postTypeID, title, parentID, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteID = _ref.siteID, postTypeID = _ref.postTypeID, title = _ref.title, parentID = _ref.parentID;
            _context.next = 3;
            return (0, _.db)('createPost', {
              siteID: siteID,
              title: title,
              postTypeID: postTypeID,
              parentID: parentID
            }, dispatch, config);

          case 3:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addPost(_x, _x2, _x3) {
    return _ref10.apply(this, arguments);
  };
}();

exports.addPost = addPost;

var getPost = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2, dispatch, config) {
    var siteID, postID, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            siteID = _ref2.siteID, postID = _ref2.postID;
            _context2.next = 3;
            return (0, _.db)('getPost', {
              siteID: siteID,
              postID: postID
            }, dispatch, config);

          case 3:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getPost(_x4, _x5, _x6) {
    return _ref11.apply(this, arguments);
  };
}();

exports.getPost = getPost;

var updatePost = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3, dispatch, config) {
    var siteID, id, postTypeID, title, slug, status, content, seo, parentID, taxonomies, featuredImage, template, templateObject, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteID = _ref3.siteID, id = _ref3.id, postTypeID = _ref3.postTypeID, title = _ref3.title, slug = _ref3.slug, status = _ref3.status, content = _ref3.content, seo = _ref3.seo, parentID = _ref3.parentID, taxonomies = _ref3.taxonomies, featuredImage = _ref3.featuredImage, template = _ref3.template, templateObject = _ref3.templateObject;
            _context3.next = 3;
            return (0, _.db)('updatePost', {
              siteID: siteID,
              id: id,
              postTypeID: postTypeID,
              title: title,
              slug: slug,
              status: status,
              content: JSON.stringify(content),
              seo: JSON.stringify(seo),
              parentID: parentID,
              taxonomies: JSON.stringify(taxonomies),
              featuredImage: JSON.stringify(featuredImage),
              template: template,
              templateObject: JSON.stringify(templateObject)
            }, dispatch, config);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updatePost(_x7, _x8, _x9) {
    return _ref12.apply(this, arguments);
  };
}();

exports.updatePost = updatePost;

var deletePost = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref4, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            siteID = _ref4.siteID, id = _ref4.id;
            _context4.next = 3;
            return (0, _.db)('deletePost', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context4.sent;
            return _context4.abrupt("return", result);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function deletePost(_x10, _x11, _x12) {
    return _ref13.apply(this, arguments);
  };
}();

exports.deletePost = deletePost;

var emptyTrash = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5, dispatch, config) {
    var siteID, postTypeID, result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            siteID = _ref5.siteID, postTypeID = _ref5.postTypeID;
            _context5.next = 3;
            return (0, _.db)('emptyTrash', {
              siteID: siteID,
              postTypeID: postTypeID
            }, dispatch, config);

          case 3:
            result = _context5.sent;
            return _context5.abrupt("return", result);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function emptyTrash(_x13, _x14, _x15) {
    return _ref14.apply(this, arguments);
  };
}();

exports.emptyTrash = emptyTrash;

var duplicatePost = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            siteID = _ref6.siteID, id = _ref6.id;
            _context6.next = 3;
            return (0, _.db)('duplicatePost', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context6.sent;
            return _context6.abrupt("return", result);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function duplicatePost(_x16, _x17, _x18) {
    return _ref15.apply(this, arguments);
  };
}();

exports.duplicatePost = duplicatePost;

var reorderPosts = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref7, dispatch, config) {
    var siteID, postIDs, result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            siteID = _ref7.siteID, postIDs = _ref7.postIDs;
            _context7.next = 3;
            return (0, _.db)('reorderPosts', {
              siteID: siteID,
              postIDs: JSON.stringify(postIDs)
            }, dispatch, config);

          case 3:
            result = _context7.sent;
            return _context7.abrupt("return", result);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function reorderPosts(_x19, _x20, _x21) {
    return _ref16.apply(this, arguments);
  };
}();

exports.reorderPosts = reorderPosts;

var refreshPostLock = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref8, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            siteID = _ref8.siteID, id = _ref8.id;
            _context8.next = 3;
            return (0, _.db)('refreshPostLock', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context8.sent;
            return _context8.abrupt("return", result);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function refreshPostLock(_x22, _x23, _x24) {
    return _ref17.apply(this, arguments);
  };
}();

exports.refreshPostLock = refreshPostLock;

var removePostLock = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref9, dispatch, config) {
    var siteID, id, result;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            siteID = _ref9.siteID, id = _ref9.id;
            _context9.next = 3;
            return (0, _.db)('removePostLock', {
              siteID: siteID,
              id: id
            }, dispatch, config);

          case 3:
            result = _context9.sent;
            return _context9.abrupt("return", result);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function removePostLock(_x25, _x26, _x27) {
    return _ref18.apply(this, arguments);
  };
}();

exports.removePostLock = removePostLock;